import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = ({ pageRange = 3 }) => {
  const height = 185;
  const body = new Array(pageRange).fill(null).map((i, ind) => {
    let yStrip;

    if (ind === 0) {
      yStrip = 17;
    } else {
      yStrip = 61 * (ind - 1) + 91;
    }

    return (
      <React.Fragment key={ind}>
        {ind ? (
          <>
            <rect x="0" y={yStrip} rx="3" ry="3" width="57" height="12" />
            <rect x="83" y={yStrip} rx="3" ry="3" width="255" height="12" />
            <rect x="356" y={yStrip} rx="3" ry="3" width="10" height="12" />
            <rect x="454" y={yStrip} rx="3" ry="3" width="70" height="12" />
            <rect x="599" y={yStrip} rx="3" ry="3" width="70" height="12" />
            <rect x="719" y={yStrip - 11} rx="3" ry="3" width="117" height="37" />
          </>
        ) : (
          <>
            <rect x="0" y={yStrip} rx="3" ry="3" width="57" height="12" />
            <rect x="83" y={yStrip} rx="3" ry="3" width="100" height="12" />
            <rect x="356" y={yStrip} rx="3" ry="3" width="78" height="12" />
            <rect x="454" y={yStrip} rx="3" ry="3" width="125" height="30" />
            <rect x="599" y={yStrip} rx="3" ry="3" width="100" height="30" />
            <rect x="719" y={yStrip} rx="3" ry="3" width="125" height="12" />
          </>
        )}
      </React.Fragment>
    );
  });

  return (
    <ContentLoader
      speed={2}
      width={840}
      height={height}
      viewBox={`0 0 840 ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb">
      <>{body}</>
    </ContentLoader>
  );
};

export default Loader;
